export const callType = [
    {
        label: 'All', value: 'All'
    },
    {
        label: 'Incoming', value: 'Incoming'
    },
    {
        label: 'Outgoing', value: 'Outgoing'
    },
    {
        label: 'Missed', value: 'Missed'
    },
    {
        label: 'Rejected', value: 'Rejected'
    },
    /* {
        label: 'Hide Calls without Leads', value: 'calls_without_leads'
    },
    {
        label: 'Hide Zero Duration', value: 'zero_duration'
    } */
];

export const chartsList = [
    {
        label: 'TOTAL CALLS BY USER', value: 'bar_chart', isHorizontal : true, type: 'total_calls_by_user', colordistributed: true, tooltip: 'count', operation: 'GET_CALLDATA_BY_USERS'
    },
    {
        label: 'TOTAL CALLS BY TYPE', value: 'bar_chart', isHorizontal : true, type: 'total_calls_by_type', colordistributed: true, tooltip: 'count', operation: 'GET_TOTAL_CALL_BY_TYPE'
    },
    {
        label: 'TOTAL CALLS BY TIME', value: 'bar_chart', isHorizontal : false, type: 'total_calls_by_Time', colordistributed: false, tooltip: 'count', operation: 'GET_TOTAL_CALL_BY_TIME'
    },
    {
        label: 'CALL DURATION BY TIME', value: 'bar_chart', isHorizontal : false, type: 'call_duration_by_time', colordistributed: false, tooltip: 'time', operation: 'GET_CALL_DURATION_BY_TIME'
    }
];

export const toperReports = [
    {
        label : 'Topper by Calls', 
        image : '', 
        value : 'call_analysis',
        data : [
            {
                header : 'Top Dialer',
                contant : '',
                body : [
                    {
                        fields : 'Dialed Calls : ',
                    }
                ],
            },
            {
                header : 'Top Answered',
                contant : '',
                body : [
                    {
                        fields : 'Received Calls : ',
                    }
                ],
            },
            {
                header : 'Top Caller',
                contant : '',
                body : [
                    {
                        fields : 'Total Calls : ',
                    }
                ],
            },
        ],
        desc : 'The most calls made, received, or both, among all employees.'
    },
    {
        label : 'Topper by Duration', 
        image : '', 
        value : 'total_call_duration_analysis',
        data : [
            {
                header : 'Highest Total Duration',
                contant : '',
                body : [
                    {
                        fields : 'Duration : ',
                    }
                ],
            },
            {
                header : 'Longest Duration',
                contant : '',
                body : [
                    {
                        fields : 'Duration : ',
                    },
                    {
                        fields : 'Call To : ',
                    },
                    {
                        fields : 'Call Time : ',
                    },
                ],
            },
        ],
        desc : 'The highest total call duration (incoming and outgoing) among all employees, and the longest call duration (incoming or outgoing) from a single mobile number among all.'
    },
    {
        label : 'Average Calls Duration', 
        image : '', 
        value : 'average_call_duration_analysis',
        data : [
            {
                header : 'Average Duration per Incoming Call',
                contant : '',
            },
            {
                header : 'Average Duration per Outgoing Call',
                contant : '',
            },
            {
                header : 'Average Duration per Call',
                contant : '',
            },
            {
                header : 'Average Duration per Day',
                contant : '',
            },
        ],
        desc : 'The average call duration (incoming and outgoing) among all employees, both per call and per day.'
    },
];
